import { render, staticRenderFns } from "./ai-wen.vue?vue&type=template&id=49f5e2bf&scoped=true"
import script from "./ai-wen.vue?vue&type=script&lang=ts"
export * from "./ai-wen.vue?vue&type=script&lang=ts"
import style0 from "./ai-wen.vue?vue&type=style&index=0&id=49f5e2bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f5e2bf",
  null
  
)

export default component.exports